import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { translations } from "../../utils/translations.js";
import { orderTaxesNames, paymentStatus } from "../../utils/constants.ts";
import { createCardPayment } from "../../services/orderService.js";
import { useAuth } from "../../hooks/useAuth.jsx";
import { useNavigate } from "react-router-dom";

const OrdersContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const OrderItem = styled.div`
  background-color: white;
  border: 1px solid var(--background-yellow);
  border-radius: 8px;
  padding: 16px;
  margin: 4px 24px;
  justify-content: space-between;
  align-items: center;

  p {
    margin: 2px 0;
    font-size: 14px;
    font-weight: 400;
  }

  button {
    background-color: var(--background-yellow);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 8px 16px;
  }
`;

const OrderDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const OrderDetailsItem = styled.div`
  margin-top: 4px;
  border: 2px solid var(--background-yellow);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
`;

const Title = styled.p`
  width: 100%;
  border-bottom: 2px solid var(--background-yellow);
  font-size: 25px;
  padding: 16px 32px;
  font-family: Georgia, serif;
  color: var(--secondary-font-color);
  margin: 0;
`;
interface Props {
  orders: {
    orderID: string;
    orderDate: string;
    status: string;
    shippingOption: string;
    totalPrice: number;
    paymentOption: string;
    paymentStatus: string;
    paymentId: string;
    email: string;
    phoneNumber: string;
    paymentRetryNumber: number;

    street: string;
    city: string;
    county: string;

    orderDetails: {
      orderID: string;
      productID: string;
      productName: string;
      productCantity: number;
      salePrice: number;
    }[];
  }[];
  account: {
    email: string;
    phoneNumber: string;
    name: string;
  };
}

const AccountOrders: React.FC<Props> = ({ orders, account }) => {
  const languageCode = useSelector((state: any) => state.settings.languageCode);
  const { token } = useAuth();
  const navigate = useNavigate();
  const handleRetry = async (order: any) => {
    const paymentData = {
      orderNumber: `${order.orderID}.${order.paymentRetryNumber}`,
      amount: Math.round(Number(order.totalPrice) * 100),
      orderBundle: {
        customerDetails: {
          email: account.email || "",
          phone: account.phoneNumber || "",
          deliveryInfo: {
            city: order.city,
            postAddress: order.street,
          },
        },
      },
    };

    try {
      const response = await createCardPayment(paymentData, token);
      if (response?.formUrl && response?.orderId) {
        window.location.href = response.formUrl;
      } else {
        navigate("/placed-order/failed", { replace: true });
      }
    } catch (error) {
      console.error("Payment retry failed:", error);
    }
  };

  return (
    <OrdersContainer>
      <Title>{translations[languageCode]["account-orders"]}</Title>
      {orders?.length > 0 ? (
        orders.map((order) => {
          return (
            <OrderItem key={"order-" + order.orderID}>
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  borderBottom: "1px solid var(--background-yellow)",
                  paddingBottom: "8px",
                }}
              >
                <div>
                  <p>
                    {translations[languageCode]["account-orders-number"]}{" "}
                    {order.orderID}
                  </p>
                  <p>
                    {translations[languageCode]["account-orders-date"]}{" "}
                    {order.orderDate}
                  </p>
                  <p>
                    {translations[languageCode]["account-orders-payment"]}{" "}
                    {order.paymentOption}, {order.shippingOption}
                  </p>
                </div>

                <div>
                  <p>
                    {translations[languageCode]["account-orders-status"]}{" "}
                    {order.status}
                  </p>

                  <p>{order.totalPrice} lei</p>
                  {order.paymentOption === orderTaxesNames.card &&
                    (order.paymentStatus === paymentStatus.UNPAID ||
                      order.paymentStatus === paymentStatus.DECLINED ||
                      order.paymentStatus === paymentStatus.CARD_CREATED) &&
                    order.paymentRetryNumber < 5 && (
                      <button onClick={() => handleRetry(order)}>
                        Reîncercare plată
                      </button>
                    )}
                </div>
              </div>

              <OrderDetails>
                {order.orderDetails.map((item) => (
                  <OrderDetailsItem
                    key={`order-${item.orderID}-product-${item.productID}`}
                  >
                    <div style={{ display: "flex", gap: "16px" }}>
                      {item.productName} {"  x "} {item.productCantity}
                    </div>
                    <>{item.salePrice} lei / buc</>
                  </OrderDetailsItem>
                ))}
              </OrderDetails>
            </OrderItem>
          );
        })
      ) : (
        <div style={{ padding: "8px 16px" }}>
          {translations[languageCode]["account-no-orders"]}
        </div>
      )}
    </OrdersContainer>
  );
};

export default AccountOrders;
